import {
  IconCoupon,
  IconCreditCard,
  IconEnvelope,
  IconFeedbackStars,
  IconFlybuysSquare,
  IconHeartOutline,
  IconLocationPinOutline,
  IconMessage,
  IconOnePassTags,
  IconPadlock,
  IconParcel,
  IconProps,
  IconToolTip,
  IconUserAdd,
  IconUserOutline,
} from "@catchoftheday/cg-components";

type AccountMenuItem = {
  name: string;
  icon?: React.FC<IconProps>;
  /** Forcefully shrink icons that fill up their viewboxes e.g. IconOnePassTag */
  /** Regular: 18px x 18px */
  /** Shrunk: 14px x 14px */
  shrink?: boolean;
};

export const ACCOUNT_MENU_ICON_MAP: AccountMenuItem[] = [
  { name: "Orders", icon: IconParcel },
  { name: "Personal Details", icon: IconUserOutline },
  { name: "Wishlist", icon: IconHeartOutline },
  { name: "Messages", icon: IconMessage },
  { name: "OnePass Subscription", icon: IconOnePassTags, shrink: true },
  { name: "Flybuys", icon: IconFlybuysSquare },
  { name: "Coupons", icon: IconCoupon },
  { name: "Addresses", icon: IconLocationPinOutline, shrink: true },
  { name: "Payment Details", icon: IconCreditCard },
  { name: "Communications", icon: IconEnvelope },
  { name: "Reviews and Feedback", icon: IconFeedbackStars },
  { name: "Help Centre", icon: IconToolTip, shrink: true },
  { name: "Login", icon: IconUserOutline },
  { name: "Forgot Password", icon: IconPadlock },
  { name: "Sign Up", icon: IconUserAdd },
  { name: "Refer a Friend", icon: IconUserAdd },
  { name: "Logout" },
];
